import { render } from "./RVITApp.vue?vue&type=template&id=79b12b4d"
import script from "./RVITApp.vue?vue&type=script&lang=js"
export * from "./RVITApp.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__